import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { ActivePortfolioService } from '../../../shared/services/active-portfolio.service';
import { CommonModule } from '@angular/common';
import { QuotationDocument } from '../../../shared/models/active-portfolio-model/active-portfolio.model';
import { InputFileLightComponent } from '../../../shared/inputs/input-file-light/input-file-light.component';
import { DynamicPageService } from '../../../shared/services/dynamic-page.service';
import { AdditionalValuesFiles } from '../../../shared/models/pages-model/form-general.model';
import { LoadGeneralComponent } from '../../../shared/components-generals/load-general/load-general.component';
import { GeneralService } from '../../../shared/services/general.service';

@Component({
  selector: 'app-payments-docs',
  imports: [CommonModule, InputFileLightComponent, LoadGeneralComponent],
  templateUrl: './payments-docs.html',
  styleUrl: './payments-docs.css',
})
export class PaymentsDocs {
  @Input() quotationId: number = 0;
  @Input() cotStatus: string = 'COMPRADA';
  public loadService = false;
  public documents: QuotationDocument[] = [];
  public documentsForm: FormGroup = new FormGroup({});
  constructor(
    private activePortfolioService: ActivePortfolioService,
    private dynamicPageService: DynamicPageService,
    private generalService: GeneralService,
  ) {}

  ngOnInit() {
    this.getQuotationDocuments();
  }

  public getQuotationDocuments(): void {
    this.loadService = true;
    this.activePortfolioService
      .getQuotationDocuments({
        desStatus: this.cotStatus,
        idCotizacion: this.quotationId,
        inventario: 0,
      })
      .subscribe((response) => {
        this.documents = response;
        this.documents.forEach((doc) => {
          this.loadService = false;
          this.documentsForm.addControl(String(doc.ID_COTIZACION_DOCUMENTO), new FormControl(null));
        });
      });
  }

  public getFileLigh(body: {
    index: number;
    formControlGeneral: FormControl | AbstractControl;
    AdditionalValuesFiles: AdditionalValuesFiles;
  }): void {
    const files = body.formControlGeneral.value;
    if (files && files.length && files[body.index]) {
      this.dynamicPageService.viewFileLight(files[body.index], files[0].name);
      return;
    }

    this.loadService = true;
    this.dynamicPageService
      .getFile(body.AdditionalValuesFiles.systemFileName ?? '')
      .subscribe((ress) => {
        if (ress) {
          const filename = body.AdditionalValuesFiles.fileName; // O tomar del header 'Content-Disposition'
          const file = new File([ress], filename ?? '', {
            type: ress.type || 'application/octet-stream',
          });
          const updatedFiles = [...(body.formControlGeneral.value ?? []), file];
          body.formControlGeneral.setValue(updatedFiles);
          this.dynamicPageService.viewFileLight(
            body.formControlGeneral.value[body.index],
            body.formControlGeneral.value[0].name,
          );
        }
        this.loadService = false;
      });
  }

  public downloadFileLigh(body: {
    index: number;
    formControlGeneral: FormControl | AbstractControl;
    AdditionalValuesFiles: AdditionalValuesFiles;
  }): void {
    const files = body.formControlGeneral.value;
    if (files && files.length && files[body.index]) {
      const file: File = files[body.index];
      const url = URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name;
      a.click();
      URL.revokeObjectURL(url);
      return;
    }

    this.loadService = true;
    this.dynamicPageService
      .getFile(body.AdditionalValuesFiles.systemFileName ?? '')
      .subscribe((ress) => {
        if (ress) {
          const filename = body.AdditionalValuesFiles.fileName ?? 'archivo';
          const blob = new Blob([ress], { type: ress.type || 'application/octet-stream' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          a.click();
          URL.revokeObjectURL(url);
        }
        this.loadService = false;
      });
  }

  public autoSaveFileLigh(document: QuotationDocument, quotationId: number, file: File): void {
    const documentData = `{"QuotationId":${quotationId},"DocumentId":${document.ID_DOCUMENTO},"QuotationDocId":${document.ID_COTIZACION_DOCUMENTO},"CoverId":${document.ID_CARATULA},"Description":"${document.DESC_DOCUMENTO}","IsVehicle":${document.IS_VEHICLE ? 1 : 0},"IsCfdi":${document.IS_CFDI ? 1 : 0},"UserId":${localStorage.getItem('idUser') || 1}}`;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('documentData', documentData);
    this.dynamicPageService.uploadDocument(formData).subscribe((ress) => {
      if (!ress.hasErrors) {
        this.generalService.viewSnacAlert(
          'Archivo subido',
          'normal',
          document.DESC_DOCUMENTO + ' guardado',
        );
      } else {
        this.generalService.viewSnacAlert(
          'A ocurrido un error',
          'alert',
          'Error al guardar ' + document.DESC_DOCUMENTO,
        );
      }
    });
  }
}
